import React, {useEffect,useState,useRef} from 'react';
//import useGoogleCaptcha from '../../components/useReCaptcha.tsx.js';
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import {getDomain, isForbiddenDomainName} from '../../helpers/helpers.js'
import {Link} from "react-router-dom";
import FAQ from '../../components/faqComponent.js'

import {RtFAQItem, APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiFullScanStartResults, RtSecurityScanPageResult} from '../../../../server/routes/cve-security-scan.js'


// Interface for component props
interface CVEFullScanProps {
    server: string;
    pageData: unknown;
}
// Interface for CVE scan form props
interface CVEScanFormProps {
    reCaptchaSiteKey: string;
    props: RtSecurityScanPageResult;
    google?: wts_approved_any;
}

export default function Scan({server, pageData}: CVEFullScanProps) {

    let [data, setData] = useState(pageData as RtSecurityScanPageResult);

    let faqs: RtFAQItem[] = [];

    data.faqs.forEach((f) => {
        const outFAQItem: RtFAQItem = {
            ...f,
            questionhtml: f.questionhtml ? f.questionhtml : f.question,
            answerhtml: f.answerhtml ? f.answerhtml : f.answer,
            skipFromJson: f.skipFromJson ? true : false
        }
        faqs.push(outFAQItem);
    })


	return (
        <>
             <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                        <h3 style={{wordWrap: 'break-word'}}>Security Scan</h3>
                            <p>
                            Quickly scan your website for known vulnerabilities in outdated or insecure technologies, including popular CMS platforms 
                            (such as WordPress, Joomla, and Drupal), JavaScript libraries (like jQuery and React), and WordPress themes and plugins.
                            Receive detailed reports highlighting potential security risks to help you safeguard your site.               
                            </p>
                            <p>
                            <SampleSecurityReports />
                            </p>
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <CVEScanForm    
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey}
                                /*google={google}*/
                                /> 
                            <FAQ faqs={faqs}  expanded='1'/>
                        </div>
                    </div> 
                </div> 
            </section>
        </>
    )
}

function SuccessMessage(domainList: string[]): string {
    if (!domainList || !domainList.length) return '';

    const domains = domainList.sort();
    let sites = '';
    domains.forEach((d, index) => {
        const isLast = index === domains.length - 1;
        if (sites.length) {
            if (isLast) 
            sites += ` and `;
        else
            sites += `, `;
        }

        sites += `<b>${d}</b>`;
    }) ;

    if (domainList.length >= 6)
        return `You’ve successfully verified ownership of ${domainList.length} domains. Security scans can now be performed on these domains and their subdomains.`;
    if (domainList.length >= 2)
        return `You’ve verified ownership of ${sites}. You can now run security scans on these domains and their subdomains.`
    else
        return `You’ve verified ownership of ${sites}. You can now perform security scans on this domain and its subdomains.`
}

function CVEScanForm({reCaptchaSiteKey, props, google}: CVEScanFormProps) {
    const listNotEmpty = (props.VerifiedDomains && !!props.VerifiedDomains.length);
    const success_msg = listNotEmpty ? SuccessMessage(props.VerifiedDomains) : '';
    const error_msg = listNotEmpty ? '' : `You must verify domain ownership before starting security scans.<br/>Just sign up with an <b>email from your domain</b>!`;

    const initialFlashProps: FlashMessageData = {}

    const [flashProps, setFlashProps] = useState(initialFlashProps);

	const CVE = undefined; //props.CVE;
	const domain = props.Domain;

    let domainControl = useRef<HTMLInputElement>(null);
    let ownerShipdomain = domainControl.current ? domainControl.current.value : domain

      function SendCVEScan (cve: string | undefined, domain: string, deepScan: boolean, permissionToScan: boolean, captcha: wts_approved_any): void {
        var requestBody = JSON.stringify({
			cve, domain, deepScan, permissionToScan, captcha
            });

// https://127.0.0.1:3001/cve-security-scan/api-full-scan/microformats.org
    
        fetch( `/cve-security-scan/api-full-scan`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then((result: Response) => {
            return result.json();
        }).then((untypedData: unknown) => {

            const data = untypedData as APIResponse<RtApiFullScanStartResults>;
           if (data.results && data.results.status == 'started') { 

             console.log("domain="+data.results.domainToBeScanned);

				// // https://127.0.0.1:3001/cve/api-scan-results/example.com	
				document.location = `/cve-security-scan/results?scanid=${data.results.scanId}`;   
            } else {
                //console.log(JSON.stringify(data));
                if (data.err){				
                    setFlashProps({error_msg: data.err})
                }
                else {
                    setFlashProps({error_msg: "Scan failed"})
                }
             }
            //grecaptcha.reset();
    
        }).catch((e: unknown) => {
            console.error( "Exception", e );                   
            setFlashProps({error_msg: "Unknown error"});
        });
    };   
    function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        const captcha = undefined;//grecaptcha.getResponse();
        const form = event.currentTarget;
        const domainElement = form.elements.namedItem('domain') as HTMLInputElement;
		const domain = getDomain(domainElement.value);
        const deepScanElement = form.elements.namedItem('deepScan') as HTMLInputElement;
        const deepScan = deepScanElement ? deepScanElement.checked : false;
        const permissionElement = form.elements.namedItem('permissionToScan') as HTMLInputElement;
        const permissionToScan = permissionElement.checked;

		if (domain != null){
			if (isForbiddenDomainName(domain)) {
                setFlashProps({error_msg: "Scanning of this website is not permitted"})              
			} else {

                // if (!captcha) {
                //     setFlashProps({error_msg: "Please select CAPTCHA"});
                // }
                // else {
                // SendCVEScan ...
                // }

                SendCVEScan(
                    CVE,
                    domain,
                    deepScan,
                    permissionToScan,
                    captcha);

			}
		} else {
            setFlashProps({error_msg:  "Please enter a valid domain name"});
		}
   
      }
    return (      
        <>
        <form action='#' method="GET" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Please provide the website to test for CVE vulnerabilities"
                    placeholder="Please provide the website to test for CVE vulnerabilities"
                    defaultValue={domain}
                    required
                    ref={domainControl}
                />                
            </div>      
            <div className="form-group">
				<input type="checkbox" id="permissionToScan" name="permissionToScan"/>
				{' '}
				<label htmlFor="permissionToScan"> 
				I am authorized to conduct security scans on this domain.
				</label>
				<br/>
			</div>  
            <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Scan Domain</button>
            </div>
        </form>  
        <Link 
            className="btn btn-primary" 
            title='Verified Websites list'
            to={ ownerShipdomain ? `/user/verified-domains/add-domain?domain=${ownerShipdomain}` : '/user/verified-domains/add-domain'}
            style={{ marginLeft: "auto", float: 'right' }} 
        >
        Verify Domain Ownership
        </Link>	         
    </>
   )
  
}

function SampleSecurityReports() {
    return (
        <>
            <Link 
                target="_blank" 
                to={`/cve-security-scan/results?scanid=scan-sample`}
                className="link-hover" 
                title={`Sample Security Scan Report`} 
            >
                Sample Report&nbsp;
                <span className="icon text-right fa fa-external_link"></span>     
            </Link>
        </>
    );
}